import routerConstants from "./routerConstants";
import { role } from '../constants/roleConstants'
import { UserOutlined, MenuOutlined, TeamOutlined, CopyOutlined, ProjectOutlined, HomeOutlined, AppstoreAddOutlined, SettingOutlined } from '@ant-design/icons';
import { getManagedHeThongIds } from '@utils/userUtils';

export type AdminMenuItem = {
    key: string
    startPoint: string
    path: string
    label: string
    icon: any
    children: any[]
}

export const adminMenu: AdminMenuItem[] = [

    {
        key: 'menu',
        startPoint: routerConstants.menu.name,
        path: routerConstants.menu.list,
        label: 'Menu',
        icon: MenuOutlined,
        children: []
    },
    {
        key: 'toChuc',
        startPoint: 'to-chuc',
        path: routerConstants.duAn.list,
        label: 'Tổ chức',
        icon: SettingOutlined,
        children: [
            {
                key: 'duAn',
                startPoint: 'du-an',
                path: routerConstants.duAn.list,
                label: 'Mảng & chi nhánh',
                icon: ProjectOutlined,
            },
            {
                key: 'khoVatLy',
                startPoint: 'kho-vat-ly',
                path: routerConstants.khoVatLy.list,
                label: 'Kho vật lý',
                icon: HomeOutlined,
            },
            {
                key: 'subAdmin',
                startPoint: 'sub-admin',
                path: '/sub-admin',
                label: 'Quản lý sub-admin',
                icon: TeamOutlined,
            },
        ],
    },
    {
        key: 'user',
        startPoint: routerConstants.user.name,
        path: routerConstants.user.list,
        label: 'Nhân viên',
        icon: UserOutlined,
        children: []
    },
    {
        key: 'roleGroup',
        startPoint: 'role-group',
        path: routerConstants.roleGroup.list,
        label: 'Nhóm quyền',
        icon: TeamOutlined,
        children: []
    },
    {
        key: 'roleGroupBulkChucNang',
        startPoint: 'role-group/bulk-chuc-nang',
        path: routerConstants.roleGroup.bulkChucNang,
        label: 'Gắn chức năng hàng loạt',
        icon: AppstoreAddOutlined,
        children: []
    },
    {
        key: 'copyRoleAssignment',
        startPoint: 'copy-role-assignment',
        path: routerConstants.copyRoleAssignment.copy,
        label: 'Copy nhóm quyền',
        icon: CopyOutlined,
        children: []
    },

]

// Sub-admin: Nhân viên + Nhóm quyền + gắn chức năng hàng loạt (không copy / tổ chức)
export const subAdminMenu: AdminMenuItem[] = adminMenu.filter(
    (item) =>
        item.key === 'user'
        || item.key === 'roleGroup'
        || item.key === 'roleGroupBulkChucNang',
)

export const userMenu = (user_role: string) => {
    if (user_role === role.SUPPER_ADMIN) {
        return adminMenu
    }
    if (getManagedHeThongIds().length > 0) {
        return subAdminMenu
    }
    return [] as AdminMenuItem[]
}
